export default [
    {
        path: "/point-of-sale",
    component: () => import("@/components/General/DashboardHeader.vue"),
    children: [
            {
                path: '/point-of-sale',
                name: 'point-of-sale',
                component: () => import('./POS.vue'),
        }
    ]
}
]